import { Component, OnInit, OnChanges, Input, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DataService } from '../../shared/dataservice.service';
import { GenService } from '../../shared/gen-ser.service';
import { NotificationsService } from 'angular2-notifications';
import { InprocessQualComponent } from '../../summary-page/inprocess-qual/inprocess-qual.component';
import { InprocessQualityIssues, IQIToken, IQIDayToken, SeverityStatus } from '../../shared/misc-classes';
@Component({
  selector: 'app-quality-app-new',
  templateUrl: './quality-app-new.component.html',
  styleUrls: ['./quality-app-new.component.css']
})
export class QualityAppNewComponent implements OnChanges {

  dateSel :number = 0;  
  mId:string = "";
  selDate:Date = new Date();
  @Input() selMonth: string;
  @Input() selProductType: string;
  inProcessQualObj:Array<IQIToken>;
  qualityData:any;
  mergeObj:Array<IQIToken>;
  fieldSelection:any;
  comments:any;
  @ViewChild('childModal') public childModal:ModalDirective;
  constructor(public _dataService:DataService,private _notify:NotificationsService) { }

  ngOnChanges() {
    
    this.qualityData = [];
    this.loadInprocessData();
  }
  loadInprocessData(){
    this.qualityData = [];
    this._dataService.getQualityGembaCardData(new Date(this.selMonth), this.selProductType).subscribe((_tmpInpQualIssues:Array<IQIToken>) => {
      if(_tmpInpQualIssues!=null){
          this.inProcessQualObj = _tmpInpQualIssues;
          this.createQualityData();
        // this.compareProductType();
      }
    })
  }
  // compareProductType(){
  //   this.mergeObj = new InprocessQualityIssues(this.inProcessQualObj.id,this.inProcessQualObj.monthDateNum,[]);
  //   for(var w=0;w<this.inProcessQualObj.dayTokens.length;w++){
  //    for(var h=0; h<this.inProcessQualObj.dayTokens[w].dateTokens.length;h++){
  //      var _tmp1 = this.inProcessQualObj.dayTokens[w].dateTokens[h];

  //       if(_tmp1.productType == this.selProductType){
  //        if(this.mergeObj.dayTokens.length == 0){
  //          if(_tmp1.createdDate)
  //          this.mergeObj.addDateToken(_tmp1.createdDate,new IQIToken(_tmp1.rowId,_tmp1.productName,_tmp1.productType,_tmp1.productDesc,_tmp1.quantity,_tmp1.issueRelated,_tmp1.supplierName,_tmp1.ncrCapturing,_tmp1.issueCapturing,_tmp1.defectCategory,_tmp1.defectSubCategory1,_tmp1.defectSubCategory2,_tmp1.defectSubCategory3,_tmp1.rootCause,_tmp1.dispositionDecision,_tmp1.actionDecided,_tmp1.preventiveAction,_tmp1.respPrsn,_tmp1.targetDateNum,_tmp1.status,_tmp1.shortageNotes,_tmp1.creationDate,_tmp1.severityValue))
  //         }
  //        else{
  //          var dateMatched = false;
  //          for(var v=0;v<this.mergeObj.dayTokens.length;v++){
  //           console.log(this.mergeObj)
  //            if(this.mergeObj.dayTokens[v].selDate == this.inProcessQualObj.dayTokens[w].dateTokens[h].createdDate){
  //              dateMatched = true;
  //              let temp:IQIToken;
  //              temp = (new IQIToken(_tmp1.rowId,_tmp1.productName,_tmp1.productType,_tmp1.productDesc,_tmp1.quantity,_tmp1.issueRelated,_tmp1.supplierName,_tmp1.ncrCapturing,_tmp1.issueCapturing,_tmp1.defectCategory,_tmp1.defectSubCategory1,_tmp1.defectSubCategory2,_tmp1.defectSubCategory3,_tmp1.rootCause,_tmp1.dispositionDecision,_tmp1.actionDecided,_tmp1.preventiveAction,_tmp1.respPrsn,_tmp1.targetDateNum,_tmp1.status,_tmp1.shortageNotes,_tmp1.creationDate,_tmp1.severityValue))
  //              this.mergeObj.dayTokens[v].addToken(temp)
  //            }             
             
  //          }
  //          if(dateMatched == false){
  //              this.mergeObj.addDateToken(this.inProcessQualObj.dayTokens[w].dateTokens[h].createdDate,new IQIToken(_tmp1.rowId,_tmp1.productName,_tmp1.productType,_tmp1.productDesc,_tmp1.quantity,_tmp1.issueRelated,_tmp1.supplierName,_tmp1.ncrCapturing,_tmp1.issueCapturing,_tmp1.defectCategory,_tmp1.defectSubCategory1,_tmp1.defectSubCategory2,_tmp1.defectSubCategory3,_tmp1.rootCause,_tmp1.dispositionDecision,_tmp1.actionDecided,_tmp1.preventiveAction,_tmp1.respPrsn,_tmp1.targetDateNum,_tmp1.status,_tmp1.shortageNotes,_tmp1.creationDate,_tmp1.severityValue))
  //         }
  //        }
        
  //      }
  //    }
  //   }
  //   this.createQualityData(this.mergeObj)
  // }
  getDateFormatStr(_date, _format){
    switch(_format){
        case "DD":
            return _date.getDate();
    }
  return ''
  }

  createQualityData(){
    let _tmpDailyTokenList: Array<any> = [];
        for (var i = 0; i < this.inProcessQualObj.length; i++) {
          let  _tempArray = <any>{};
           _tempArray._selDate = this.getDateFormatStr(this.inProcessQualObj[i].selDate,"DD");
           _tempArray._selArray=[];
           let redFlag = false;
           let blueFlag = false;
           let greenFlag = false;
           let _tmpFlag;
          // for(var a=0;a < prodHighObj.dayTokens[i].dateTokens.length; a++){
            if(this.inProcessQualObj[i].severityValue == SeverityStatus.Disturbance){
              blueFlag = true;
              var _tmp =<any>{};
                  _tmp.productId = this.inProcessQualObj[i].productName;
                  _tmp.supplierName = this.inProcessQualObj[i].supplierName;
                  _tmp.productType = this.inProcessQualObj[i].productType;
                  _tmp.shortageNotes = this.inProcessQualObj[i].shortageNotes;
                  _tempArray._selArray.push(_tmp);
                  _tempArray._flag="blue";
            }
            else if(this.inProcessQualObj[i].severityValue == SeverityStatus.Production_Loss){
              redFlag = true;
              var _tmp =<any>{};
                  _tmp.productId =this.inProcessQualObj[i].productName;
                  _tmp.supplierName = this.inProcessQualObj[i].supplierName;
                  _tmp.productType = this.inProcessQualObj[i].productType;
                  _tmp.shortageNotes = this.inProcessQualObj[i].shortageNotes;
                  _tempArray._selArray.push(_tmp)
            }
            else if(this.inProcessQualObj[i].severityValue == null || this.inProcessQualObj[i].severityValue == SeverityStatus.Not_A_Concern){
                greenFlag = true;
            }
           //}
           
           if(redFlag){
            _tempArray._selFlag = 2
           }
           else if(blueFlag == true && redFlag == false){
            _tempArray._selFlag = 1;              
           }
           else if(blueFlag == false && redFlag == false && greenFlag == true){
            _tempArray._selFlag = 0;
           }
           else if(blueFlag == false && redFlag == false && greenFlag == false){
            _tempArray._selFlag = -1;
           }
           _tmpDailyTokenList.push(_tempArray)
           
        }
      this.qualityData = _tmpDailyTokenList;
      //console.log("Quality Data here:" +JSON.stringify(this.qualityData));
      }
  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  openModal(num){
    this.selDate = new Date((new Date(this.selMonth)).setDate(num))
    this.fieldSelection={};
    this.fieldSelection.selArray=[];
    if(this.qualityData){
      for(var i=0;i<this.qualityData.length;i++){
         if(this.qualityData[i]._selDate == num){ 
           for(var g=0; g<this.qualityData[i]._selArray.length;g++){            
            this.fieldSelection.selArray.push(this.qualityData[i]._selArray[g]);
           }
           this.fieldSelection.flag = this.qualityData[i]._selFlag;
         }
      }
     // console.log(this.fieldSelection.selArray)
  }
     this.childModal.show();
  }
  public hideChildModal():void {
    this.childModal.hide();
  }
  getProductType(type:string){
    if(type){
      return this._dataService.getProductType(type);
    }
  }
  formatMonth(_dateObj:string):string{
    let dateObj = new Date(_dateObj);
    if(dateObj){
      return GenService.getDateFormatStr(dateObj , "MMM-YYYY");
    }
    return '-';
  }
  addColor(num){
    var isFound = false;
    if(this.qualityData && this.qualityData.length>0){
        for(var i=0;i<this.qualityData.length;i++){
          if(this.qualityData[i]._selDate == num){
            isFound = true;
            if(this.qualityData[i]._selFlag == 0){
                return 'green'
            }
            else if(this.qualityData[i]._selFlag == 1){
              return 'blue'
            }
            else if(this.qualityData[i]._selFlag == 2){
              return 'red'
            }
            else{
              return 'green'
            }       
          }
      }
    }
    if(!isFound){
      if(!this.selProductType)
        return 'white'
      else{
        var _tmpDate = new Date(this.selMonth);
        if(num < _tmpDate.getDate() && _tmpDate.getMonth() == new Date().getMonth() && _tmpDate.getFullYear() == new Date().getFullYear()){
          var day = new Date(_tmpDate.setDate(num)).getDay();
          if(day == 0 || day == 6)
              return 'white'
          else
              return 'green'
        }
        else if(_tmpDate.getMonth() < new Date().getMonth() && _tmpDate.getFullYear() <= new Date().getFullYear()){ 
          var day = new Date(_tmpDate.setDate(num)).getDay();
          if(day == 0 || day == 6)
            return 'white'
        else
          return 'green'
        }
        else if(_tmpDate.getMonth() > new Date().getMonth() && _tmpDate.getFullYear() < new Date().getFullYear()){ 
          var day = new Date(_tmpDate.setDate(num)).getDay();
          if(day == 0 || day == 6)
            return 'white'
        else
          return 'green'
        }
        else
          return 'white'
      }
    }
  }
  


}
